import { render, staticRenderFns } from "./RecommendationProductCard.vue?vue&type=template&id=73cebe5d"
import script from "./RecommendationProductCard.vue?vue&type=script&lang=js"
export * from "./RecommendationProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports